import type { Placement } from '@floating-ui/react'
import { clsx } from 'clsx'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import bombPotSvg from '../../../assets/images/modes/bomb-pot.svg'
import doubleBoardSvg from '../../../assets/images/modes/double-board.svg'
import { Icon, Tooltip } from '../../atoms'
import { TooltipContent, TooltipTrigger } from '../../atoms/Tooltip'
import * as styles from './index.css'

interface DoubleBoardType {
  mode: 'doubleBoard'
}

interface BombPotType {
  mode: 'bombPot'
  params: {
    min: number
    max: number
    frequency: number
    activateDoubleBoard: boolean
  }
}

export const ModeIcon = (
  props: (DoubleBoardType | BombPotType) & {
    placement?: Placement
    className?: string
  },
) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const tooltipByMode: Record<typeof props.mode, string> = {
    doubleBoard: t('modeIcon.doubleBoard.tooltip'),
    bombPot: t(
      'modeIcon.bombPot.tooltip',
      props.mode === 'bombPot' ? props.params : undefined,
    ),
  }
  const iconByMode: Record<typeof props.mode, string> = {
    doubleBoard: doubleBoardSvg,
    bombPot: bombPotSvg,
  }

  return (
    <Tooltip
      open={open}
      placement={props.placement}
      onOpenChange={setOpen}
    >
      <TooltipTrigger
        className={clsx(styles.tooltipWrapper, props.className)}
        onClick={() => setOpen((state) => !state)}
      >
        <Icon
          src={iconByMode[props.mode]}
          className={styles.tooltipWrapper}
          analytic={{
            name: 'mode_icon',
            params: {
              mode: props.mode,
            },
          }}
        />
      </TooltipTrigger>
      <TooltipContent>{tooltipByMode[props.mode]}</TooltipContent>
    </Tooltip>
  )
}
